import { render, staticRenderFns } from "./education_history_yukon.vue?vue&type=template&id=2e0d28ef&"
import script from "./education_history_yukon.vue?vue&type=script&lang=js&"
export * from "./education_history_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports